module.exports = __webpack_public_path__ + "assets/img/ROC.25fd288d.svg";